import * as Yup from "yup";

export const purposeOfDisclosureValidations = section => {
    if (section.active) {
        return Yup.object().shape({
            disclosurePurposeGroup: section.fields.disclosurePurposeGroup.validations.required.value && Yup.string().required(
                () =>
                    section.fields.disclosurePurposeGroup.validations.required.message
            ),
            disclosurePurposeGroupOther: Yup.string()
                .when("disclosurePurposeGroup", {
                    is: val => val === "other",
                    then: Yup.string().required(
                        section.fields.disclosurePurposeGroupOther.validations.required
                            .message
                    )
                })
                .max(
                    section.fields.disclosurePurposeGroupOther.validations.maxLength.value,
                    section.fields.disclosurePurposeGroupOther.validations.maxLength.message
                )
        });
    } else { return Yup.object().shape(); }
};
